import { ResourceData, ResourceId, useBaseCrudService } from 'framework/crud';
import { useFinanceApi } from 'infrastructure/api';
import vendorNoteValidation from './shared/form/vendorNoteValidation';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { VENDOR_DOCUMENT_TYPES } from '../../vendorDocuments/constants';
import { useVendorId } from 'domain/finance/vendors/routes';

export const CREATE_VENDOR_NOTE_PERMISSION = 'CREATE_NOTE';
export const READ_VENDOR_NOTES_PERMISSION = 'READ_CANDIDATE_NOTES';

const useVendorNoteService = () => {
  const id = useVendorId();
  const { uploadDocument } = useDocumentStorageContext();
  const { update } = useBaseCrudService({
    listResourceUrl: '/vendors/notes',
    singleResourceUrl: '/vendors/notes/:id',
    useService: useFinanceApi,
  });
  const updateTimelineItem = async (entityId: ResourceId, data: ResourceData) => {
    try {
      let attachments = data.attachments || [];

      if (attachments.length) {
        const commitFiles = await uploadDocument({
          vendorId: id,
          fileType: VENDOR_DOCUMENT_TYPES.OTHER,
          paths: attachments,
        });
        attachments = commitFiles.paths || [];
      }

      return update(entityId, {
        ...data,
        attachments,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to update timeline item:', error);
      throw error;
    }
  };

  return {
    getValidationSchema: () => Promise.resolve(vendorNoteValidation),
    update: updateTimelineItem,
  };
};

export default useVendorNoteService;
